// styles
import './styles/tarot-carousel.css';

// main Tarot class
import Tarot from './scripts/tarot.js';

// base effect class for external effects
import TarotEffect from './scripts/effects/tarot-effect.js';

// include custom HTML elements
import './scripts/core/custom-elements.js';

// Core plugins are now built-in to Tarot

// Process any effects that were queued before Tarot loaded
(function() {
	if (typeof window !== 'undefined' && Array.isArray(window.TarotEffectQueue)) {
		window.TarotEffectQueue.forEach(function(item) {
			if (item && item.factory) {
				// Factory pattern: create class and register
				var EffectClass = item.factory(TarotEffect);
				Tarot.registerEffect(EffectClass);
			} else if (typeof item === 'function') {
				// Legacy: direct class
				Tarot.registerEffect(item);
			}
		});
	}
	// Replace queue with proxy that registers immediately (for effects that load after)
	if (typeof window !== 'undefined') {
		window.TarotEffectQueue = {
			push: function(item) {
				if (item && item.factory) {
					var EffectClass = item.factory(TarotEffect);
					Tarot.registerEffect(EffectClass);
				} else if (typeof item === 'function') {
					Tarot.registerEffect(item);
				}
			}
		};
	}
})();

// Process any plugins that were queued before Tarot loaded
(function() {
	if (typeof window !== 'undefined' && Array.isArray(window.TarotPluginQueue)) {
		window.TarotPluginQueue.forEach(function(item) {
			if (item && item.plugin) {
				Tarot.registerPlugin(item.plugin);
			} else if (typeof item === 'function') {
				Tarot.registerPlugin(item);
			}
		});
	}
	// Replace queue with proxy that registers immediately (for plugins that load after)
	if (typeof window !== 'undefined') {
		window.TarotPluginQueue = {
			push: function(item) {
				if (item && item.plugin) {
					Tarot.registerPlugin(item.plugin);
				} else if (typeof item === 'function') {
					Tarot.registerPlugin(item);
				}
			}
		};
	}
})();

// register as custom element (guarded for hot reload / duplicate script loads)
if (!customElements.get('tarot-carousel')) {
	customElements.define('tarot-carousel', Tarot);
}

// Export everything as named exports (modern ESM pattern)
export { Tarot as default }; // Main class as default export
export { Tarot, TarotEffect }; // Base class for effects
